import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import VacationModal from "./components/VacationModal";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Gallery from "./pages/Gallery";
import Reviews from "./pages/Reviews";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Admin from "./pages/Admin";
import Kitchen from "./pages/Kitchen";
import OrderTracking from "./pages/OrderTracking";
import PrintReceipt from "./pages/PrintReceipt";
import ASZF from "./pages/ASZF";
import Privacy from "./pages/Privacy";
import Impresszum from "./pages/Impresszum";

function App() {
  return (
    <BrowserRouter>
      <CartProvider>
        <Routes>
          {/* Main routes with Header and Footer */}
          <Route path="/" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow"><Home /></main>
              <Footer />
            </div>
          } />
          <Route path="/menu" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow"><Menu /></main>
              <Footer />
            </div>
          } />
          <Route path="/gallery" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow"><Gallery /></main>
              <Footer />
            </div>
          } />
          <Route path="/reviews" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow"><Reviews /></main>
              <Footer />
            </div>
          } />
          <Route path="/about" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow"><About /></main>
              <Footer />
            </div>
          } />
          <Route path="/contact" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow"><Contact /></main>
              <Footer />
            </div>
          } />
          <Route path="/cart" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow"><Cart /></main>
              <Footer />
            </div>
          } />
          <Route path="/checkout" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow"><Checkout /></main>
              <Footer />
            </div>
          } />
          <Route path="/order-tracking" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow"><OrderTracking /></main>
              <Footer />
            </div>
          } />
          <Route path="/track-order/:orderNumber" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow"><OrderTracking /></main>
              <Footer />
            </div>
          } />
          
          {/* Legal pages */}
          <Route path="/aszf" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow"><ASZF /></main>
              <Footer />
            </div>
          } />
          <Route path="/adatvedelmi-tajekoztato" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow"><Privacy /></main>
              <Footer />
            </div>
          } />
          <Route path="/impresszum" element={
            <div className="flex flex-col min-h-screen">
              <Header />
              <main className="flex-grow"><Impresszum /></main>
              <Footer />
            </div>
          } />

          {/* Admin and Kitchen - Full screen, no header/footer */}
          <Route path="/admin" element={<Admin />} />
          <Route path="/kitchen" element={<Kitchen />} />

          {/* Standalone receipt-print page — bypasses Android Chrome print
              pipeline by triggering rawbt:base64 URI directly. */}
          <Route path="/print/:orderNumber" element={<PrintReceipt />} />
        </Routes>
        {/* Site-wide vacation pop-up — shows on customer-facing pages when the
            owner enables "Szabadság" in the admin panel. Hides itself on
            /admin, /kitchen and /print routes. */}
        <VacationModal />
        {/* Toast notifications with close button and auto-dismiss */}
        <Toaster 
          position="top-right" 
          closeButton
          duration={3500}
          toastOptions={{
            style: {
              background: 'white',
              color: '#111',
              border: '1px solid #e5e7eb',
              borderRadius: '12px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
              padding: '12px 16px',
            },
            className: 'toast-custom',
          }}
        />
      </CartProvider>
    </BrowserRouter>
  );
}

export default App;
